// Editoryal mühür amblemi — klasik sütun motifli dairesel nişan. Elle çizilmiş kimlik.
export const BrandMark = ({ size = 40, withBg = false, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {withBg && <circle cx="24" cy="24" r="22.5" fill="#F7F2E9" />}
    <circle cx="24" cy="24" r="22" fill="none" stroke="#1F1A14" strokeWidth="1.4" />
    <circle cx="24" cy="24" r="18.4" fill="none" stroke="#1F1A14" strokeWidth="0.7" />
    <rect x="16.4" y="12.5" width="15.2" height="1.8" fill="#9E2F50" />
    <rect x="14.6" y="14.9" width="18.8" height="2.6" rx="0.5" fill="#1F1A14" />
    <g stroke="#1F1A14" strokeWidth="1.15" strokeLinecap="round">
      <line x1="17.6" y1="18.6" x2="17.6" y2="29.4" />
      <line x1="20.8" y1="18.6" x2="20.8" y2="29.4" />
      <line x1="24" y1="18.6" x2="24" y2="29.4" />
      <line x1="27.2" y1="18.6" x2="27.2" y2="29.4" />
      <line x1="30.4" y1="18.6" x2="30.4" y2="29.4" />
    </g>
    <rect x="13.8" y="30" width="20.4" height="2.8" rx="0.5" fill="#1F1A14" />
    <rect x="16.4" y="33.7" width="15.2" height="1.8" fill="#9E2F50" />
  </svg>
);

export default BrandMark;
